import { render } from "./Contacts.vue?vue&type=template&id=e60d3a0c"
import script from "./Contacts.vue?vue&type=script&lang=js"
export * from "./Contacts.vue?vue&type=script&lang=js"

import "./Contacts.vue?vue&type=style&index=0&id=e60d3a0c&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__